import React from 'react'
import styles from './index.module.less'
import { useLang } from '@/common/utils/i18n'

interface HighlightTextProps {
  children?: React.ReactNode;
  highlightClassName?: string;
  highlightStyle?: React.CSSProperties;
  textPosition?: 'left' | 'right' | 'center';
}

const EmptyText = () => <span>&nbsp;</span>
const HighlightText: React.FC<HighlightTextProps> = ({
  children = '',
  highlightClassName = '',
  highlightStyle = {},
  textPosition = 'left',
}) => {
  const currentLang = useLang()
  const isEn = currentLang === 'en'
  const prefix = isEn && textPosition !== 'left' ? <EmptyText/> : null
  const suffix = isEn && textPosition !== 'right' ? <EmptyText/> : null
  return (
    <span>
      {prefix}
      {
        children?.split('').map(text => (
          <span
            className={`${styles.highlight} ${highlightClassName}`}
            style={highlightStyle}
          >
            {text?.trim() ? text?.trim() : <EmptyText/>}
          </span>
        ))
      }
      {suffix}
    </span>
  )
}

export default HighlightText
